export default __webpack_public_path__ + "static/media/icon-payment.38ada420.svg";